<template>
  <div class="input-group month-year-group">
    <select
      v-model="monthYear.month"
      class="form-control"
      @change="updateInput"
    >
      <option
        v-for="month in months"
        :key="month.value"
        :value="month.value"
      >
        {{ month.text }}
      </option>
    </select>
    <input
      v-model="monthYear.year"
      type="number"
      class="form-control"
      min="1900"
      max="2999"
      @change="updateInput"
    >
  </div>
</template>

<script>
    export default {
        data: () => ({
            months: [
                {value: '01', text: 'Janeiro'},
                {value: '02', text: 'Fevereiro'},
                {value: '03', text: 'Março'},
                {value: '04', text: 'Abril'},
                {value: '05', text: 'Maio'},
                {value: '06', text: 'Junho'},
                {value: '07', text: 'Julho'},
                {value: '08', text: 'Agosto'},
                {value: '09', text: 'Setembro'},
                {value: '10', text: 'Outubro'},
                {value: '11', text: 'Novembro'},
                {value: '12', text: 'Dezembro'}
            ],
            monthYear: {
                month: null,
                year: null
            }
        }),
        methods: {
            updateInput() {
                let data = null
                if (this.monthYear.year && this.monthYear.month){
                    data = this.monthYear.year + '-' + this.monthYear.month
                }
                this.$emit('input', data)
            }
        }
    }
</script>

<style scoped>
    .month-year-group .form-control {
        width: 50%;
    }
</style>
